import React from "react";

import Admins from "../../components/Tables/Admins/Admins";

const ListOfAdminUsers = () => <Admins />;

export default ListOfAdminUsers;
